import React from 'react'
import * as prismic from '@prismicio/client'
import { useSelector } from 'react-redux'
import cms from 'front-end-core/decorators/cms'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import ContentPanelsContainer from 'redux/containers/pages/dashboard/ContentPanelsContainer'
import selectAolName from 'redux/selectors/selectAolName'

const ContentPanelsWrapper = (props) => (
  <ResponseConsumer
    response={props.CMS_DATA}
    content={() => <ContentPanelsContainer {...props} />}
  />
)

const ContentPanelsCMSWrapper = ({ cmsCtx, ...props }) => {
  const aol = useSelector(selectAolName)

  if (!cmsCtx) {
    return null
  }
  const query = {
    predicates: [
      prismic.predicate.at('document.type', 'fc_homepage_content_panels'),
      prismic.predicate.at('my.fc_homepage_content_panels.area_of_law', aol)
    ]
  }

  const CmsComponent = cms({ request: (cmsCtx) => cmsCtx.api.get(query) })(ContentPanelsWrapper)

  return <CmsComponent {...{ ...props, aol, cmsCtx }} />
}

export default ContentPanelsCMSWrapper
